<div class="auto-pay-promotion-banner" [ngClass]="{'autopay-billing-width': isBillingRoute, 'default-width': isDetailsRoute}">
    <div class="promotion-title">
        <div>{{ "Enable Autopay now" | translate }}</div>
        <div>{{ "LET_US_DO_THE_WORK_FOR_YOU" | translate }}</div>
    </div>
    <div class="promotion-action">
        <div class="row">
            <div class="col" [ngClass]="{'no-padding-horizontal': isAcmic, 'display-promotion': !isAcmic}">
                <mapfre-button
                [routerLink]="['/billing', 'autopay']"
                additionalClasses="promotion-enroll" [ngClass]="{'autopay-acmic-enrll': isAcmic}" >{{ "Enroll in Autopay" | translate }}
            </mapfre-button>
            <mapfre-button *ngIf="!isAcmic && showCompnay==='ma'" 
                [routerLink]="['/faq', 'autopay']"
                additionalClasses="promotion-question" [ngClass]="{'question-margin': !isAcmic}">{{ "HAVE_QUESTIONS" | translate }}
            </mapfre-button>
            </div>        
    </div>
    </div>
</div>